<!-- save-changes-modal.component.html -->
<div class="save-changes-modal-all">
  <div class="save-changes-modal-header">
    <h5 class="modal-title">
      {{ "financial-information.save_changes_modal.title" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close(false)"
    ></button>
  </div>

  <div class="save-changes-modal-body">
    <div>
      <p class="modal-text">
        {{
          "financial-information.save_changes_modal.text_modified" | translate
        }}
      </p>
      <p class="modal-text">
        {{ "financial-information.save_changes_modal.text_prompt" | translate }}
      </p>

      <p class="modal-sub-title m-0">
        {{
          "financial-information.save_changes_modal.sub_title_event_type"
            | translate
        }}
      </p>
      <span class="modal-text">
        {{ "financial-information.save_changes_modal.event_type" | translate }}
      </span>
    </div>

    <form [formGroup]="commentForm" class="form-container">
      <label for="">
        {{
          "financial-information.save_changes_modal.label_comment" | translate
        }}*
      </label>
      <textarea
        class="form-control"
        rows="4"
        formControlName="comment"
        maxlength="150"
        [placeholder]="
          'financial-information.save_changes_modal.placeholder_comment'
            | translate
        "
      ></textarea>
      <div class="form-text text-end">
        {{ commentForm.get("comment")?.value.length || 0 }}/150
      </div>
    </form>
  </div>

  <div class="save-changes-modal-footer">
    <button
      type="button"
      class="btn-save"
      [disabled]="commentForm.invalid"
      (click)="onConfirm()"
    >
      {{ "financial-information.save_changes_modal.button_save" | translate }}
    </button>
  </div>
</div>
